export default "__VITE_ASSET__CiwDwaYm__"